import React from 'react';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { Text, TextType } from 'ui-components/components/text';
import { AddShipFromLink } from '../ship-from-step/ship-from-cards/add-ship-from-link';
import { messages } from './messages';
import style from './style.module.less';

/**
 * Link component for adding ship-from location
 * @returns {JSX.Element} The AddShipFromLinkComponent
 */
const AddShipFromLinkComponent = () => (
  <AddShipFromLink buttonText={messages.addShipFromLinkText} className={style['ship-from-link']} showIcon={false} />
);

/**
 * Banner component that displays when user has no ship-from locations
 * @returns {JSX.Element} The NoShipFromBanner component
 */
export const NoShipFromBanner = () => {
  return (
    <BannerMessageV2
      content={
        <Text
          formattedMessageValues={{
            link: AddShipFromLinkComponent,
          }}
          textType={TextType.Paragraph}
          value={messages.noShipFromBannerMessage}
        />
      }
      layout={BannerLayout.Full}
      status={BannerStatus.Error}
    />
  );
};
